import { useMemo, useState } from 'react';
import {
  getTrueDataFeedbackHistoryNew,
  // delTrueDataFeedbackHistory,
} from '@/pages/intelligence/services/topcharts';
import { useDeepCompareEffect } from 'ahooks';

// 真实数据反馈公共hooks
const usePublicTrueDataModel = (props: any) => {
  const { entityType, gameId, openTrue } = props || {};
  // console.log('usePublicTrueDataModel', props);

  const [tableFeedBackData, setTableFeedBackData] = useState<any>([]);
  const [tableFeedBackDataTotal, setTableFeedBackDataTotal] = useState(0);
  const [gameIdValue, setGameIdValue] = useState(gameId);
  const [entityTypeValue, setEntityTypeValue] = useState(entityType);
  // pageId
  const pageId = useMemo(() => `${gameId},${entityType}`, [entityTypeValue, gameIdValue]);

  const defaultGetParams = {
    entity_type: entityTypeValue,
    game_id: gameIdValue,
    page_id: '',
    page: 1,
    page_size: 5,
    order_metric: 'fill_time',
    order: 'desc',
  } as any;

  const [feedBackParams, setFeedBackParams] = useState(defaultGetParams);
  const [openFeedBackTable, setOpenFeedBackTable] = useState(openTrue);
  useDeepCompareEffect(() => {
    setGameIdValue(gameId);
  }, [gameId]);

  useDeepCompareEffect(() => {
    setEntityTypeValue(entityType);
  }, [entityType]);

  // 获取反馈历史记录
  const fetchTrueDataFeedbackHistory = async (paramsValue: any, isNeedOpenTable = false) => {
    const params = {
      ...paramsValue,
      ...feedBackParams,
      page: paramsValue?.page ?? 1,
      page_size: paramsValue?.page_size ?? 5,
      order_metric: paramsValue?.order_metric ?? 'fill_time',
      order: paramsValue?.order ?? 'desc',
      page_id: '',
    } as any;
    // setIsRecordLoading(true);
    setFeedBackParams(params);
    try {
      const res = await getTrueDataFeedbackHistoryNew(params);
      const dataList: any = res?.data?.history || [];
      const total  = res?.data?.count || 0;
      setTableFeedBackDataTotal(total);
      setTableFeedBackData([...dataList]);

      if(isNeedOpenTable) {
        setOpenFeedBackTable(isNeedOpenTable);
      };
    } catch (err) {
    }
    finally {
      // setIsRecordLoading(false);
    }
  };

  // 删除反馈历史记录
  // const fetchDelTrueDataFeedbacHistory = async (id: number | string) => {
  //   const params = {
  //     id: Number(id),
  //   } as any;
  //   try {
  //     await delTrueDataFeedbackHistory(params);
  //     fetchTrueDataFeedbackHistory(feedBackParams);
  //   } catch (err) { }
  //   finally {
  //   }
  // };

  return {
    tableFeedBackData,
    tableFeedBackDataTotal,
    pageId,
    fetchTrueDataFeedbackHistory,
    setGameIdValue,
    setEntityTypeValue,
    gameIdValue,
    entityTypeValue,
    feedBackParams,
    openFeedBackTable,
    setOpenFeedBackTable,
  };
};

export default usePublicTrueDataModel;
